<!-- Fixed Header -->
<div class="dialog-header d-flex justify-content-between align-items-center">
  <div class="d-flex align-items-center header-left">
    <div class="icon-circle me-3">
      <mat-icon class="text-primary">verified</mat-icon>
    </div>
    <div class="header-text">
      <h3 class="dialog-title mb-0">Product Claim Details</h3>
      <div class="dialog-subtitle text-muted">Warranty validation & registration timeline</div>
    </div>
  </div>
  <button mat-icon-button (click)="onClose()" aria-label="Close" class="close-btn me-n1">
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- Scrollable Content Body: Vertical scroll only -->
<mat-dialog-content class="dialog-content-body">
  <!-- Product & Serial Summary Box -->
  <div class="summary-card mb-3">
    <div class="d-flex flex-wrap justify-content-between align-items-start gap-2">
      <div>
        <span class="text-uppercase tracking-wider text-muted font-11 fw-bold">Serial Number / Product Code</span>
        <div class="serial-code mt-1">{{ data.productCode }}</div>
        <div class="product-title mt-1">
          {{ data.productName || 'Product' }}
        </div>
        <div class="product-category text-muted" *ngIf="data.categoryName">
          <mat-icon class="inline-icon">category</mat-icon> {{ data.categoryName }}
        </div>
        <div class="mt-2" *ngIf="data.claimedItemName">
          <div class="claimed-part-chip">
            <mat-icon class="claimed-part-icon">hub</mat-icon>
            <span class="claimed-part-label">Claimed Part:</span>
            <strong class="claimed-part-name">{{ data.claimedItemName }}</strong>
            <span class="claimed-part-warranty">({{ data.claimedItemWarranty || 0 }} Yrs Warranty)</span>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column align-items-end gap-1">
        <span class="status-pill" [ngClass]="data.isEligibleAtClaimTime ? 'status-eligible' : 'status-ineligible'">
          <mat-icon class="status-icon">{{ data.isEligibleAtClaimTime ? 'check_circle' : 'cancel' }}</mat-icon>
          {{ data.isEligibleAtClaimTime ? 'Eligible at Claim' : 'Ineligible at Claim' }}
        </span>
        <span class="status-pill status-claimed">
          <mat-icon class="status-icon">fact_check</mat-icon>
          {{ data.status || 'Claimed' }}
        </span>
      </div>
    </div>
  </div>

  <!-- Timeline 4-Card Grid -->
  <div class="section-label mb-2">
    <mat-icon class="section-icon">schedule</mat-icon> Timeline Dates
  </div>
  <div class="dates-grid mb-3">
    <!-- Mfg Date -->
    <div class="date-card">
      <span class="date-label">Manufacturing</span>
      <div class="date-value">{{ (data.mfgDate | date : 'dd/MM/yyyy') || 'N/A' }}</div>
    </div>

    <!-- Registration Date -->
    <div class="date-card">
      <span class="date-label">Registration</span>
      <div class="date-value">{{ (data.registeredDate | date : 'dd/MM/yyyy') || 'N/A' }}</div>
    </div>

    <!-- Claim Date -->
    <div class="date-card highlight-claim">
      <span class="date-label">Claim Date</span>
      <div class="date-value text-primary">{{ (data.claimDate | date : 'dd/MM/yyyy') || 'N/A' }}</div>
    </div>

    <!-- Last Eligible Date -->
    <div class="date-card highlight-limit">
      <span class="date-label">Last Eligible Date</span>
      <div class="date-value text-danger">{{ (data.lastEligibleDate | date : 'dd/MM/yyyy') || 'N/A' }}</div>
    </div>
  </div>

  <!-- Applied Rule Details -->
  <div class="rule-card mb-3">
    <div class="d-flex align-items-start">
      <mat-icon class="rule-icon me-2">rule</mat-icon>
      <div class="flex-grow-1">
        <div class="d-flex flex-wrap align-items-center justify-content-between gap-2">
          <span class="fw-semibold text-dark font-13">Applied Business Rule:</span>
          <span class="rule-badge" [ngClass]="data.ruleApplied?.includes('MFG') ? 'rule-mfg' : 'rule-reg'">
            {{ data.ruleDescription }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Customer Details (if present) -->
  <div class="customer-card mb-2" *ngIf="data.user && (data.user.username || data.user.phone)">
    <div class="section-label mb-2">
      <mat-icon class="section-icon">person</mat-icon> Customer Information
    </div>
    <div class="customer-grid">
      <div class="customer-item" *ngIf="data.user.username">
        <span class="item-label">Name</span>
        <span class="item-value">{{ data.user.username }}</span>
      </div>
      <div class="customer-item" *ngIf="data.user.phone">
        <span class="item-label">Phone</span>
        <span class="item-value">{{ data.user.phone }}</span>
      </div>
      <div class="customer-item" *ngIf="data.user.companyName">
        <span class="item-label">Company</span>
        <span class="item-value">{{ data.user.companyName }}</span>
      </div>
      <div class="customer-item" *ngIf="data.user.city || data.user.state">
        <span class="item-label">Location</span>
        <span class="item-value">
          {{ data.user.city }}{{ data.user.city && data.user.state ? ', ' : '' }}{{ data.user.state }} {{ data.user.pincode }}
        </span>
      </div>
    </div>
  </div>
</mat-dialog-content>

<!-- Fixed Footer -->
<div class="dialog-footer d-flex justify-content-end align-items-center">
  <button mat-flat-button color="primary" class="close-action-btn" (click)="onClose()">
    Close
  </button>
</div>
